import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {AutoplayOptions, CancelStartSpinReason, CoreDI, inject, SlotSettings} from '@gongxigames/framework/slot';
import {uiAutoplayOptionsStore} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/uiAutoplayOptionsStore';

export class UIAutoplayOptionsService extends UiServiceV2 {
    public static NAME = 'UIAutoplayOptionsService';

    // TODO convert to signals/move to store
    @inject(CoreDI.Settings)
    protected _settings!: SlotSettings;

    onInit(): void {
        uiAutoplayOptionsStore.autoplayValues.value = this._settings.get('autoplayValues');

        let defaultSpins = this._settings.get('autoplayValues')[0];

        if (this._settings.get('autoplayDefaultSelectedSpins') !== undefined) {
            defaultSpins = this._settings.get('autoplayValues')[this._settings.get('autoplayDefaultSelectedSpins')];
        }

        uiAutoplayOptionsStore.defaultSpins.value = defaultSpins;
    }

    public onSetupEvents(): void {
        this.emitter.on('UI.autoplayOptions.Close', this.onClose.bind(this));
        this.emitter.on('UI.autoplayOptions.QuickSpin', this.onQuickSpin.bind(this));
        this.emitter.on('UI.autoplayOptions.TurboSpin', this.onTurboSpin.bind(this));
        this.emitter.on('UI.autoplayOptions.UntilBonus', this.onUntilBonus.bind(this));
        this.emitter.on('UI.autoplayOptions.SingleWin', this.onSingleWin.bind(this));
        this.emitter.on('UI.autoplayOptions.WinLimit', this.onWinLimit.bind(this));
        this.emitter.on('UI.autoplayOptions.LossLimit', this.onLossLimit.bind(this));
        this.emitter.on('UI.autoplayOptions.StartAutoplay', this.onStartAutoplay.bind(this));

        this.emitter.on('UI.autoplayButton.pressed', this.onStartAutoplayButton.bind(this));
        // TODO @Stepan should we rewrite $AutoplaySettings to make them reactive relatively to disabledLimits
        this.emitter.on('General.Game.LOGIC_INITIALIZED', this.onGameLogicInitialized.bind(this));
    }

    protected onGameLogicInitialized(): void {
        uiAutoplayOptionsStore.disabledLimits.value = this._settings.get('allAutoplayLimitsDisabled');
    }

    private onClose(): void {
        slotStore.isAutoplayOptionsPopup.value = false;

        this.emitter.emit('Game.command.round.uiEnabled');
    }

    private onQuickSpin(isQuickSpin: boolean): void {
        return this.emitter.emit('UI.reelSpin.setLevel', isQuickSpin ? ReelsSpeedLevel.turbo_1 : ReelsSpeedLevel.normal);
    }

    private onTurboSpin(isTurboSpin: boolean): void {
        return this.emitter.emit('UI.reelSpin.setLevel', isTurboSpin ? ReelsSpeedLevel.turbo_2 : ReelsSpeedLevel.normal);
    }

    private onUntilBonus(value: boolean): void {
        slotStore.feature_autoplayUntilBonusEnabled.value = value;
        slotStore.feature_autoCloseScreensEnabled.value = !value;
    }

    private onSingleWin(value: number | null): void {
        uiAutoplayOptionsStore.singleWin.value = value;
    }

    private onWinLimit(value: number | null): void {
        uiAutoplayOptionsStore.winLimit.value = value;
    }

    private onLossLimit(value: number | null): void {
        uiAutoplayOptionsStore.lossLimit.value = value;
    }

    private onStartAutoplay(value: number): void {
        this.emitter.emit('Game.command.round.uiEnabled');
        slotStore.isAutoplayOptionsPopup.value = false;

        const {winLimit, lossLimit, singleWin, turboSpin} = uiAutoplayOptionsStore.values();

        const autoplayOptions: AutoplayOptions = {
            turboMode: turboSpin,
            singleWin,
            winLimit,
            lossLimit,
            autoplaySpins: value,
        };

        this.emitter.emit('UI.command.startAutoplay', autoplayOptions);
    }

    protected onStartAutoplayButton(): void {
        if (!slotStore.logic_canSpin.value) {
            this.emitter.emit('General.Flow.cancelStartSpin', {
                reason: CancelStartSpinReason.INSUFFICIENT_FUNDS,
                balanceRefreshCallback: this.onStartAutoplayButton.bind(this)
            });

            return;
        }

        slotStore.isAutoplayOptionsPopup.value = true;
        slotStore.soundPlayer.value?.play('openuipopup');
        this.emitter.emit('Game.command.round.uiDisabled');
    }
}